

angular
.module('inkfinder')
.factory('ResetPasswordFactory', function ResetPasswordFactory(
  $rootScope,
  $state,
  $http,
  AlertMessages,
  ENDPOINT,
  Auth,
  Events,
  Session,
  $cookies,
  $auth
) {
  ResetPasswordFactory.sendResetEmail = sendResetEmail;
  ResetPasswordFactory.sendNewPassword = sendNewPassword;

/**
  * @name sendResetEmail
  * @description Send password reset request to server
  * @param {string} email The email address to perform the reset workflow on
  * @return {object} Returns a promise from $http
  */
  function sendResetEmail(email) {
    return $http.post(ENDPOINT.server +
    'collectors/api/v1.1/password/reset/', {
      email: email
    })
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

/**
  * @name sendNewPassword
  * @description Send new passwords to server
  * @param {object} request The object containing the password, token, and uid
  * @return {object} Returns a promise from $http
  */
  function sendNewPassword(request) {
    return $http.post(ENDPOINT.server +
    'collectors/api/v1.1/password/reset/confirm/', {
      uid: request.uid,
      token: request.token,
      password1: request.password,
      password2: request.password_confirm
    })
    .then(function(response) {
      AlertMessages.add({msg: response.data, type: 'success'});
      $state.go('login');
      $rootScope.$broadcast('clear-data');
      Events.loggedIn = false;
      Session.destroy(); // Remove roles, token, and collector
      $cookies.remove('inkfinder');
      $auth.logout(); // Satellizer logout
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return ResetPasswordFactory;
});



// WEBPACK FOOTER //
// ./components/reset-password/reset-password.service.js